import { render, staticRenderFns } from "./folloup.vue?vue&type=template&id=34a136d2"
import script from "./folloup.vue?vue&type=script&lang=js"
export * from "./folloup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports